"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Check = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const invisible_1 = __importDefault(require("../invisible/invisible"));
const check_style_1 = __importDefault(require("./check.style"));
class Check extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            hasFocus: false
        };
        this.id = lodash_uniqueid_1.default('cb_');
        this.handleFocus = e => {
            window.clearTimeout(this.timer);
            this.setState({
                hasFocus: true
            });
            this.props.handleFocus(e);
        };
        this.handleBlur = e => {
            window.clearTimeout(this.timer);
            this.timer = window.setTimeout(() => {
                this.setState({
                    hasFocus: false
                });
                this.props.handleBlur(e);
            }, 50);
        };
        this.handleChange = e => {
            if (this.props.disabled)
                return;
            this.props.handleChange(e);
        };
        this.render = () => {
            const { classes, checked, inputRef, label, invert, disabled, showLabel, isDark, largeLabel, bold, darkLabel, indeterminate } = this.props;
            const { hasFocus } = this.state;
            const rootProps = {
                className: classes.root,
                'data-is-disabled': disabled,
                title: label
            };
            const labelProps = {
                className: classes.label,
                'data-is-inverted': invert,
                'data-is-largelabel': largeLabel,
                'data-is-bold': bold,
                'data-is-darklabel': darkLabel
            };
            const checkboxProps = {
                className: classes.checkbox,
                'data-is-checked': checked,
                'data-has-focus': hasFocus,
                'data-is-dark': isDark,
                'data-is-indeterminate': indeterminate
            };
            const inputProps = {
                className: classes.input,
                id: this.id,
                checked,
                type: 'checkbox',
                disabled,
                onFocus: this.handleFocus,
                onBlur: this.handleBlur,
                onChange: this.handleChange,
                ref: inputRef
            };
            return (jsx_runtime_1.jsxs("label", Object.assign({}, rootProps, { htmlFor: this.id }, { children: [jsx_runtime_1.jsx(invisible_1.default, Object.assign({ visible: showLabel }, { children: jsx_runtime_1.jsx("div", Object.assign({}, labelProps, { children: label }), void 0) }), void 0),
                    jsx_runtime_1.jsx("div", Object.assign({}, checkboxProps, { children: jsx_runtime_1.jsx("input", Object.assign({}, inputProps), void 0) }), void 0)] }), void 0));
        };
    }
}
exports.Check = Check;
Check.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    label: prop_types_1.default.node.isRequired,
    checked: prop_types_1.default.bool,
    handleFocus: prop_types_1.default.func,
    handleBlur: prop_types_1.default.func,
    handleChange: prop_types_1.default.func,
    inputRef: prop_types_1.default.func,
    invert: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    showLabel: prop_types_1.default.bool,
    isDark: prop_types_1.default.bool,
    largeLabel: prop_types_1.default.bool,
    bold: prop_types_1.default.bool,
    darkLabel: prop_types_1.default.bool,
    indeterminate: prop_types_1.default.bool
};
Check.defaultProps = {
    checked: false,
    handleFocus: () => { },
    handleBlur: () => { },
    handleChange: () => { },
    inputRef: () => { },
    invert: false,
    disabled: false,
    showLabel: false,
    isDark: false,
    largeLabel: false,
    bold: false,
    darkLabel: false,
    indeterminate: false
};
exports.default = react_jss_1.default(check_style_1.default)(Check);
//# sourceMappingURL=index.js.map